import React, { useCallback, useContext, useEffect, useState } from "react";

import dayjs from "dayjs";
import { matchIsValidTel } from "mui-tel-input";
import AsArray from "components/helpers/AsArray";
import JoinOjects from "components/helpers/JoinObjects";
import { pick } from "components/helpers/Utils";
import useQueryQueue from "components/hooks/useQueryQueue";
import ValidarCUIT from "components/validators/ValidarCUIT";
import GestionOSTable from "./GestionOSTable";
import GestionOSForm from "./GestionOSForm";
import moment from "moment/moment";
import AuthContext from "store/authContext";
import useAmbitos from "components/hooks/useAmbitos";
import ValidarEmail from "components/validators/ValidarEmail";
import GestionOSComprobante from "./GestionOSComprobante";
import { pdf } from "@react-pdf/renderer";
import filterFactory, {
  selectFilter,
  Comparator,
} from "react-bootstrap-table2-filter";

//ultimo modificado

const selectionDef = {
  action: "",
  request: "",
  index: null,
  record: null,
  edit: null,
  apply: [],
  errors: null,
};

export const onLoadSelectFirst = ({ data, multi, record }) => {
  const dataArray = AsArray(data);
  if (multi) {
    record = AsArray(record);
    let retorno = dataArray.filter((d) => record.find((r) => r.id === d.id));
    if (retorno.length === 0) retorno = [dataArray.at(0)].filter((r) => r);
    return retorno.length ? retorno : null;
  }
  return dataArray.find((r) => r.id === record?.id) ?? dataArray.at(0);
};

export const onLoadSelectSame = ({ data, multi, record }) => {
  const dataArray = AsArray(data);
  if (multi) {
    record = AsArray(record);
    let retorno = dataArray.filter((d) => record.find((r) => r.id === d.id));
    return retorno.length ? retorno : null;
  }
  return dataArray.find((r) => r.id === record?.id) ?? dataArray.at(0);
};

export const onLoadSelectKeep = ({ record }) => record;

export const onLoadSelectKeepOrFirst = ({ data, multi, record }) =>
  record ?? onLoadSelectFirst({ data, multi, record });

export const onDataChangeDef = (data = []) => { };

const onDownloadComprobanteGestion = (data = {}) => {
  const doc = (
    <GestionOSComprobante
      nombre={data.nombre}
      fecha={data.fecha}
      seccional={data.seccional}
      obraSocial={data.obraSocial}
    />
  );

  pdf(doc)
    .toBlob()
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `ConstanciaGestion_${data.nroGestion}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    });
};

const useGestionOS = ({
  remote: remoteInit = true,
  data: dataInit = [],
  loading,
  error,
  params: paramsInit = {},
  multi: multiInit = false,
  pagination: paginationInit = { index: 1, size: 15 },
  onLoadSelect: onLoadSelectInit = onLoadSelectFirst,
  onDataChange: onDataChangeInit = onDataChangeDef,
  columns,
  hideSelectColumn = true,
  mostrarBuscar = false,
} = {}) => {
  const { usuario } = useContext(AuthContext);
  const ambito = useAmbitos().ambitoUser();
  
  // Estado para almacenar los IDs de las seccionales de la delegación
  const [seccionalesDelegacion, setSeccionalesDelegacion] = useState([]);

  //#region Trato queries a APIs
  const pushQuery = useQueryQueue((action, params) => {
    // console.log("useFormularioOsprera, params", params);
    // console.log("useFormularioOsprera, action", action);
    switch (action) {
      case "GetList": {
        const { filtro2, ...otherParams } = params;
        return {
          config: {
            baseURL: "Afiliaciones",
            endpoint: "/GestionOsprera/GetGestionOSpreraSpec",
            method: "POST",
          },
          params: otherParams,
        };
      }

       case "EnviarCorreo": {
        return {
          config: {
            endpoint: `/Usuario/enviarCorreoConAdjuntoBase64`,
            baseURL: "Seguridad",
            method: "POST",
          },
        };
      }

      case "GetAccesoOspreraSpecs": {
        return {
          config: {
            baseURL: "Afiliaciones",
            endpoint: `/GestionOsprera/GetGestionOSpreraSpec`,
            method: "POST",
          },
        };
      }
      case "Create": {
        return {
          config: {
            baseURL: "Afiliaciones",
            endpoint: `/GestionOsprera`,
            method: "POST",
          },
        };
      }
      case "Update": {
        return {
          config: {
            baseURL: "Afiliaciones",
            endpoint: `/GestionOsprera`,
            method: "PUT",
          },
        };
      }
      case "Delete": {
        return {
          config: {
            baseURL: "Afiliaciones",
            endpoint: `/GestionOsprera/DarDeBaja`,
            method: "PATCH",
          },
        };
      }
      case "Reactiva": {
        return {
          config: {
            baseURL: "Afiliaciones",
            endpoint: `/GestionOsprera/Reactivar`,
            method: "PATCH",
          },
        };
      }

      case "GetSeccionalesSpecs": {
        return {
          config: {
            baseURL: "Afiliaciones",
            endpoint: `/Seccional?SoloActivos=true&verSeccionalesLocalidades=false`,
            method: "GET",
          },
        };
      }
      default:
        return null;
    }
  });
  //#endregion

  //#region declaracion y carga list y selected
  const [list, setList] = useState({
    loading: null,
    remote: remoteInit,
    loadingOverride: loading,
    params: {
      ...paramsInit,
      ...{
        ambitoTodos: usuario.ambitoTodos,
        ambitoProvincias: usuario.ambitoProvincias,
        ambitoDelegaciones: usuario.ambitoDelegaciones,
        ambitoSeccionales: usuario.ambitoSeccionales,
      },
    },
    pagination: { index: 1, size: 5, ...paginationInit },
    data: [...AsArray(dataInit, true)],
    seccionales: [],
    error,
    selection: {
      ...selectionDef,
      multi: multiInit,
    },
    onLoadSelect:
      onLoadSelectInit === onLoadSelectFirst && multiInit
        ? onLoadSelectSame
        : onLoadSelectInit,
    onDataChange: onDataChangeInit ?? onDataChangeDef,
  });

  //#region Cargar seccionales de la delegación si el ámbito es Delegaciones
  useEffect(() => {
    if (ambito.tipo === 'Delegaciones' && ambito.ids && ambito.ids.length > 0) {
      const delegacionId = ambito.ids[0];
      
      pushQuery({
        action: "GetSeccionalesSpecs",
        onOk: (response) => {
          // La respuesta es directamente el array o puede venir en response.data
          const seccionales = Array.isArray(response) ? response : (response?.data || []);
          
          if (Array.isArray(seccionales) && seccionales.length > 0) {
            // Filtrar seccionales por la delegación actual
            const seccionalesFiltradas = seccionales
              .filter(s => s.refDelegacionId === delegacionId && s.id !== 99999)
              .map(s => s.id);
            
            setSeccionalesDelegacion(seccionalesFiltradas);
            
            // Forzar recarga de la lista después de cargar las seccionales
            if (seccionalesFiltradas.length > 0) {
              setList((o) => ({ ...o, loading: "Cargando..." }));
            }
          }
        },
        onError: (error) => {
          console.error("Error al cargar seccionales de la delegación:", error);
        }
      });
    }
  }, [ambito.tipo, JSON.stringify(ambito.ids)]);
  //#endregion

  useEffect(() => {
    if (!list.loading) return;
    
    // Si el ámbito es Delegaciones y aún no se cargaron las seccionales, esperar
    if (ambito.tipo === 'Delegaciones' && seccionalesDelegacion.length === 0) {
      return;
    }
    
    const changes = { loading: null, error: null };
    if (!list.remote) {
      const data = list.data;
      const error = list.error;
      const multi = list.selection.multi;
      const record = list.selection.record;
      changes.data = data;
      changes.error = error;
      changes.selection = {
        ...list.selection,
        ...selectionDef,
        record: list.onLoadSelect({ data, multi, record }),
      };

      changes.selection.index = multi
        ? changes.selection.record?.map((r) => changes.data.indexOf(r))
        : changes.data.indexOf(changes.selection.record);
      setList((o) => ({ ...o, ...changes }));
      return;
    }
    changes.data = [];
    // console.log("userFormularioOsprera_list",list)
    const soloLetras = /^[A-Za-z]+$/;
    const filtro = list?.params?.filtro;
    const filtroPaciente = list?.params?.filtroPaciente;
    const filtroMedioGestion = list?.params?.filtroMedioGestion?.value;
    const filtroTipoEstado = list?.params?.filtroTipoEstado?.value;
    const filtroTipoSituacion = list?.params?.filtroTipoSituacion?.value;
    const filtroSeccional = list?.params?.filtroSeccional?.value;
    const filtroTipoGestion = list?.params?.filtroTipoGestion?.value;
    const filtroDetalleTipoGestion = list?.params?.filtroDetalleTipoGestion?.value;

    var usuarioAdulterado = {};
    if (ambito.tipo === "Seccionales") {
      usuarioAdulterado = {
        ambitoSeccionales: {
          ids: [ambito?.ids[0]],
        },
        ambitoTodos: null,
      };
    } else if (ambito.tipo === "Delegaciones") {
      if (filtroSeccional !== 0 && filtroSeccional !== undefined) {
        // Seccional específica seleccionada dentro de la delegación
        usuarioAdulterado = {
          ambitoSeccionales: { ids: [filtroSeccional] },
          ambitoTodos: null,
        };
      } else if (seccionalesDelegacion.length > 0) {
        // Todas las seccionales de la delegación
        usuarioAdulterado = {
          ambitoSeccionales: { ids: seccionalesDelegacion },
          ambitoTodos: null,
        };
      }
    } else if (ambito.tipo === "Todos" && filtroSeccional !== 0 && filtroSeccional !== undefined) {
      usuarioAdulterado = {
        ambitoSeccionales: {
          ids: [filtroSeccional],
        },
        ambitoTodos: null,
      };
    }

    const bodyToSend = {
      ...list.params,
      pageIndex: list.pagination.index,
      pageSize: list.pagination.size,
      ambitoTodos:
        filtroSeccional !== undefined && filtroSeccional !== 0
          ? usuarioAdulterado.ambitoTodos
          : ambito.tipo === "Delegaciones"
          ? null  // No usar ambitoTodos si es delegación
          : usuario.ambitoTodos,
      ambitoProvincias: usuario.ambitoProvincias,
      ambitoDelegaciones: ambito.tipo === "Delegaciones" ? null : usuario.ambitoDelegaciones,
      ambitoSeccionales:
        filtroSeccional !== undefined && filtroSeccional !== 0
          ? usuarioAdulterado.ambitoSeccionales
          : ambito.tipo === "Delegaciones" && usuarioAdulterado.ambitoSeccionales
          ? usuarioAdulterado.ambitoSeccionales
          : usuario.ambitoSeccionales,
      sort: "FechaDesc,IdDesc",
      ...(!soloLetras.test(filtro) && ValidarCUIT(filtro)
        ? { cuitTitular: filtro.replace(/[.\-\s]/g, "") }
        : { apellidoTitular: filtro }),
      ...(!soloLetras.test(filtroPaciente)
        ? { dniPaciente: filtroPaciente?.replace(/[.\-\s]/g, "") }
        : { apellidoPaciente: filtroPaciente }),
      ...(filtroMedioGestion && filtroMedioGestion !== "" && filtroMedioGestion?.toUpperCase() !== "TODOS"
        ? { medioGestion: filtroMedioGestion }
        : null),
      ...(filtroTipoEstado && filtroTipoEstado !== 0
        ? { gestionEstadoId: filtroTipoEstado }
        : null),
      ...(filtroTipoSituacion && filtroTipoSituacion !== 0
        ? { gestionSituacionId: filtroTipoSituacion }
        : null),
      ...(filtroTipoGestion && filtroTipoGestion !== 0
        ? { gestionRubroId: filtroTipoGestion }
        : null),
      ...(filtroDetalleTipoGestion && filtroDetalleTipoGestion !== 0
        ? { gestionSubRubroId: filtroDetalleTipoGestion }
        : null),
    };

    pushQuery({
      action: "GetList",
      config: {
        body: bodyToSend,
      },

      onOk: async ({ index, size, count, data }) => {
        if (!Array.isArray(data))
          return console.error("Se esperaba un arreglo", data);
        changes.data = data;
        const multi = list.selection.multi;
        const record = list.selection.record;
        changes.pagination = { index, size, count };
        changes.selection = {
          ...list.selection,
          ...selectionDef,
          record: list.onLoadSelect({ data, multi, record }),
        };

        changes.selection.index = multi
          ? changes.selection.record?.map((r) => changes.data.indexOf(r))
          : changes.data.indexOf(changes.selection.record);

        list.onDataChange(changes.data);
      },
      onError: async (error) => {
        if (error.code === 404) return;
        changes.error = error;
        changes.selection = { ...list.selection, ...selectionDef };
      },
      onFinally: async () => setList((o) => ({ ...o, ...changes })),
    });
  }, [pushQuery, list]);
  //#endregion

  const request = useCallback(
    (type, payload = {}) => {
      switch (type) {
        case "selected": {
          return setList((o) => {
            const apply = [];
            if (payload.request !== "A") {
              apply.push(
                ...AsArray(
                  "record" in payload ? payload.record : o.selection.record,
                  true
                )
                  .map(({ id }) => id)
                  .filter((r) => r)
              );
            }
            const edit = {
              ...(payload.request === "A"
                ? {}
                : JoinOjects(o.selection.record)),
              ...JoinOjects(payload.record),
            };
            return {
              ...o,
              selection: {
                ...o.selection,
                request: payload.request,
                action: payload.action,
                edit,
                apply,
              },
            };
          });
        }
        case "list": {
          return setList((o) => {
            const changes = {
              loading: null,
              data:
                "data" in payload && Array.isArray(payload.data)
                  ? [...payload.data]
                  : payload.clear
                    ? []
                    : o.data,
              loadingOverride: payload.loading,
              error: payload.error,
              onLoadSelect:
                "onLoadSelect" in payload
                  ? payload.onLoadSelect
                  : o.onLoadSelect,
              selection: {
                ...o.selection,
                multi: "multi" in payload ? !!payload.multi : o.selection.multi,
              },
            };
            if (payload.params) {
              changes.params = {
                ...pick(o.params, paramsInit),
                ...payload.params,
              };
            }
            if (payload.pagination)
              changes.pagination = { ...o.pagination, ...payload.pagination };
            if (payload.clear) {
              const data = changes.data;
              const multi = changes.selection.multi;
              const record = o.selection.record;
              changes.selection = {
                ...changes.selection,
                ...selectionDef,
                record: changes.onLoadSelect({ data, multi, record }),
              };
              changes.selection.index = multi
                ? changes.selection.record?.map((r) => changes.data.indexOf(r))
                : changes.data.indexOf(changes.selection.record);
            } else {
              changes.loading = "Cargando...";
            }
            return { ...o, ...changes };
          });
        }
        default:
          return;
      }
    },
    [pushQuery]
  );
  let form = null;
  if (list.selection.request) {
    // console.log("list", list)
    form = (
      <GestionOSForm
        data={(() => {
          //INIT DE DATOS DEL FORM
          const data =
            //seccionalId = list.selection.edit.refSeccionalId,
            ["A"].includes(list.selection.request) //INIT PARA ALTA
              ? {
                /*fecha: moment().format("YYYY-MM-DD"),
            fechaEnvioMail: null,
            direccionesEmailDestino: null,
            respuestaEnvioEmail: null,
            usuarioId: usuario?.id ?? "",*/
                seccionalId:
                  list.selection.edit.seccionalId ??
                  usuario?.ambitoSeccionales?.ids[0] ??
                  0,
                seccionalDescripcion:
                  usuario?.ambitosDescripciones[0]?.seccionalDescripcion ??
                  "",
                titularPaciente: list.selection.edit.titularPaciente ?? false,
                atencionesPrevias:
                  list.selection.edit.atencionesPrevias ?? "",
                conCoberturaOsprera:
                  list.selection.edit.conCoberturaOsprera ?? "",
                tipoPrestador: list.selection.edit.tipoPrestador ?? "",
              }
              : ["B"].includes(list.selection.request) //INIT PARA BAJA
                ? {
                  deletedDate: moment().format("YYYY-MM-DD"),
                  deletedBy: usuario.nombre,
                }
                : {};
          return { ...list.selection.edit, ...data }; //le paso el registro entero  y modifico los campos necesarios segun el request que se está haciendo
        })()}
        title={list.selection.action}
        errors={list.selection.errors}
        request={list.selection.request}
        // help={list.selection.help}
        loading={!!list.loading}
        disabled={(() => {
          // console.log("list",list);
          const r = {
            //TODOS LOS CAMPOS DESHABILITADOS POR DEFECTO
            cuitTitular: true,
            fecha: true,
            nombreTitular: true,
            apellidoTitular: true,
            telefonoContacto: true,
            telefonoContacto2: true,
            emailContacto: true,
            emailContacto2: true,
            titularPaciente: true,
            dniPaciente: true,
            nombrePaciente: true,
            apellidoPaciente: true,
            fechaNacimiento: true,
            sexo: true,
            texto: true,
            telefono: true,
            resultadoLlamada: true,
            medioGestion: true,
            tipoDocumentoId: true,
            direccionesEmailDestino: true,
            seccionalId: true,
            gestionRubro: true,
            gestionSubRubro: true,
            gestionEstado: true,
            gestionSituacion: true,
            gestionAreaOsprera: true,
            conCoberturaOsprera: true,
            tipoPrestador: true,
            atencionesPrevias: true,
            // obraSocial: true,
            observacionesEstado: true,
            gestionObraSocial: true,
          };

          if (["A"].includes(list.selection.request)) {
            r.cuitTitular = false;
          }

          if (["M"].includes(list.selection.request)) {
            // r.telefonoContacto= false;
            // r.telefonoContacto2= false;
            // r.emailContacto= false;
            // r.emailContacto2= false;
            // r.elPacienteEsTitular= false;
            // r.dniPaciente= false;
            // r.nombrePaciente= false;
            // r.apellidoPaciente= false;
            // r.fechaNacimiento= false;
            // r.sexo= false;
            // r.texto= false;
            // r.telefono= false;
            // r.resultadoLlamada= false;
            // r.medioGestion= false;
            // r.tipoDocumentoId= false;
            // r.direccionesEmailDestino= false;
            // r.gestionRubro= false;
            // r.gestionSubRubro= false;
            r.gestionEstado =
              list.selection.record.gestionEstadoId === 3 ? true : false;
            r.gestionSituacion = false;
            // r.gestionAreaOsprera= false;
          }

          if (list.selection.request !== "B") {
            r.deletedObs = true;
            r.deletedBy = true;
            r.deletedDate = true;
          }

          // Permitir selección de seccional si el ámbito es "Todos" o "Delegaciones"
          r.seccionalId = (ambito.tipo === "Todos" || ambito.tipo === "Delegaciones") ? false : true;
          return r;
        })()}
        hide={
          ["A", "M"].includes(list.selection.request)
            ? { deletedObs: true }
            : {}
        }
        onChange={(edit) => {
          // console.log("edit:",edit)
          const changes = { edit: { ...edit }, errors: {}, help: {} };
          if ("cuitTitular" in edit) {
            if (edit.cuitTitular && `${edit.cuitTitular}`.length === 11) {
              if (ValidarCUIT(edit.cuitTitular)) {
                //changes.help.cuitTitular = "Cargando...";
              } else {
                changes.errors.cuitTitular = "CUIT inválido";
              }
            } else {
              changes.errors.cuitTitular = "";
            }
          }
          setList((o) => ({
            ...o,
            selection: {
              ...o.selection,
              edit: { ...o.selection.edit, ...changes.edit },
              errors: { ...o.selection.errors, ...changes.errors },
            },
          }));
        }}
        onValidate={(confirm) => {
          const record = {
            fecha: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
            fechaEnvioMail: null,
            direccionesEmailDestino: null,
            respuestaEnvioEmail: null,
            usuarioId: usuario?.id ?? "",
            seccionalId:
              list.selection.edit.seccionalId ??
              usuario?.ambitoSeccionales?.ids[0] ??
              0,
            atencionesPrevias: "",
            conCoberturaOsprera: "",
            tipoPrestador: "",
            titularPaciente: false,
            ...list.selection.edit,
          };
          //Validaciones
          const errors = {};
          if (list.selection.request === "B") {
            if (!record.deletedObs) errors.deletedObs = "Dato requerido";
          }

          if (["A", "M"].includes(list.selection.request)) {
            if (!record.cuitTitular) errors.cuitTitular = "Dato requerido";
            else if (!ValidarCUIT(record.cuitTitular))
              errors.cuitTitular = "CUIT Incorrecto";
            if (!record.dniPaciente) errors.dniPaciente = "Dato requerido";

            if (!record.apellidoTitular)
              errors.apellidoTitular = "Dato requerido";
            if (!record.nombreTitular) errors.nombreTitular = "Dato requerido";
            if (!record.apellidoPaciente)
              errors.apellidoPaciente = "Dato requerido";
            if (!record.nombrePaciente)
              errors.nombrePaciente = "Dato requerido";
            if (!record.fechaNacimiento)
              errors.fechaNacimiento = "Dato requerido";
            if ((record.sexoId ?? 0) === 0) errors.sexoId = "Dato requerido";
            if (!record.texto) errors.texto = "Dato requerido";
            if (!record.medioGestion) errors.medioGestion = "Dato requerido";
            if (!record.tipoDocumentoId)
              errors.tipoDocumentoId = "Dato requerido";
            if (!record.seccionalId || record.seccionalId == 0)
              errors.seccionalId = "Dato requerido";
            if (
              record.medioGestion == "email" &&
              !record.direccionesEmailDestino
            )
              errors.direccionesEmailDestino = "Dato requerido";
            if (
              record.medioGestion == "email" &&
              !ValidarEmail(record.direccionesEmailDestino)
            )
              errors.direccionesEmailDestino = "Email inválido";
            if (
              record.medioGestion == "telefono" &&
              (!record.telefono || record.telefono.length <= 6)
            )
              errors.telefono = "Dato requerido";
            if (
              record.medioGestion == "telefono" &&
              (!record.telefono || !matchIsValidTel(record.telefono))
            )
              errors.telefono = "Teléfono invalido";
            if (record.medioGestion == "telefono" && !record.resultadoLlamada)
              errors.resultadoLlamada = "Dato requerido";

            if (!record.gestionRubroId || record.gestionRubroId == 0)
              errors.gestionRubro = "Dato requerido";
            if (!record.gestionSubRubroId || record.gestionSubRubroId == 0)
              errors.gestionSubRubro = "Dato requerido";
            if (!record.gestionEstadoId || record.gestionEstadoId == 0)
              errors.gestionEstado = "Dato requerido";
            if (!record.gestionSituacionId || record.gestionSituacionId == 0)
              errors.gestionSituacion = "Dato requerido";
            if (
              !record.gestionAreaOspreraId ||
              record.gestionAreaOspreraId == 0
            )
              errors.gestionAreaOsprera = "Dato requerido";

            if (
              record.telefonoContacto?.length &&
              !matchIsValidTel(record.telefonoContacto)
            )
              errors.telefonoContacto = "Teléfono de contacto inválido";
            if (
              record.telefonoContacto2?.length &&
              !matchIsValidTel(record.telefonoContacto2)
            )
              errors.telefonoContacto2 = "Teléfono de contacto 2 inválido";
            if (
              record.emailContacto?.length &&
              !ValidarEmail(record.emailContacto)
            )
              errors.emailContacto = "Email de contacto inválido";
            if (
              record.emailContacto2?.length &&
              !ValidarEmail(record.emailContacto2)
            )
              errors.emailContacto2 = "Email de contacto 2 inválido";

            if (!record.atencionesPrevias)
              errors.atencionesPrevias = "Dato requerido";
            if (record.atencionesPrevias === "S" && !record.tipoPrestador) {
              errors.tipoPrestador = "Dato requerido";
            }
            if (
              record.atencionesPrevias === "S" &&
              !record.conCoberturaOsprera
            ) {
              errors.conCoberturaOsprera = "Dato requerido";
            }

            if (!record.gestionObraSocialId)
              errors.gestionObraSocial = "Dato requerido";

            //ObservacionesEstado
            if (
              !record.observacionesEstado &&
              (record.gestionEstadoDescripcion === "RECLAMADO" ||
                (record.gestionEstadoDescripcion === "FINALIZADO" &&
                  record.gestionSituacionDescripcion === "CON RECLAMO FORMAL"))
            ) {
              errors.observacionesEstado = "Dato requerido";
            }
          }

          if (Object.keys(errors).length) {
            console.log("errors", errors);
            setList((o) => ({
              ...o,
              selection: {
                ...o.selection,
                errors,
              },
            }));
            return false;
          } else {
            return true;
          }
        }}
        onClose={(confirm) => {
          if (!["A", "B", "M", "R"].includes(list.selection.request)) {
            confirm = false;
          }
          if (!confirm) {
            setList((o) => ({
              ...o,
              selection: {
                ...o.selection,
                ...selectionDef,
                index: o.selection.index,
                record:
                  !o.selection.multi && o.selection.index > -1
                    ? o.data.at(o.selection.index)
                    : o.selection.record,
              },
            }));
            return;
          }

          const record = {
            fecha: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
            fechaEnvioMail: null,
            direccionesEmailDestino: null,
            respuestaEnvioEmail: null,
            usuarioId: usuario?.id ?? "",
            seccionalId:
              list.selection.edit.seccionalId ??
              usuario?.ambitoSeccionales?.ids[0] ??
              0,
            seccionalDescripcion:
              usuario?.ambitosDescripciones[0]?.seccionalDescripcion ?? "",
            ...list.selection.edit,
          };

          //Validaciones
          const errors = {};
          if (list.selection.request === "B") {
            if (!record.deletedObs) errors.deletedObs = "Dato requerido";
          }

          if (["A", "M"].includes(list.selection.request)) {
            if (!record.cuitTitular) errors.cuitTitular = "Dato requerido";
            else if (!ValidarCUIT(record.cuitTitular))
              errors.cuitTitular = "CUIT Incorrecto";
            if (!record.dniPaciente) errors.dniPaciente = "Dato requerido";

            if (!record.apellidoTitular)
              errors.apellidoTitular = "Dato requerido";
            if (!record.nombreTitular) errors.nombreTitular = "Dato requerido";
            if (!record.apellidoPaciente)
              errors.apellidoPaciente = "Dato requerido";
            if (!record.nombrePaciente)
              errors.nombrePaciente = "Dato requerido";
            if (!record.fechaNacimiento)
              errors.fechaNacimiento = "Dato requerido";
            if ((record.sexoId ?? 0) === 0) errors.sexoId = "Dato requerido";
            if (!record.medioGestion) errors.medioGestion = "Dato requerido";
            if (!record.tipoDocumentoId)
              errors.tipoDocumentoId = "Dato requerido";
            if (!record.seccionalId || record.seccionalId == 0)
              errors.seccionalId = "Dato requerido";

            if (
              record.medioGestion == "email" &&
              !record.direccionesEmailDestino
            )
              errors.direccionesEmailDestino = "Dato requerido";
            if (
              record.medioGestion == "email" &&
              !ValidarEmail(record.direccionesEmailDestino)
            )
              errors.direccionesEmailDestino = "Email inválido";
            if (
              record.medioGestion == "telefono" &&
              (!record.telefono || record.telefono.length <= 6)
            )
              errors.telefono = "Dato requerido";
            if (
              record.medioGestion == "telefono" &&
              (!record.telefono || !matchIsValidTel(record.telefono))
            )
              errors.telefono = "Teléfono invalido";
            if (record.medioGestion == "telefono" && !record.resultadoLlamada)
              errors.resultadoLlamada = "Dato requerido";

            if (!record.gestionRubroId || record.gestionRubroId == 0)
              errors.gestionRubro = "Dato requerido";
            if (!record.gestionSubRubroId || record.gestionSubRubroId == 0)
              errors.gestionSubRubro = "Dato requerido";
            if (!record.gestionEstadoId || record.gestionEstadoId == 0)
              errors.gestionEstado = "Dato requerido";
            if (!record.gestionSituacionId || record.gestionSituacionId == 0)
              errors.gestionSituacion = "Dato requerido";
            if (
              !record.gestionAreaOspreraId ||
              record.gestionAreaOspreraId == 0
            )
              errors.gestionAreaOsprera = "Dato requerido";

            if (
              record.telefonoContacto?.length &&
              !matchIsValidTel(record.telefonoContacto)
            )
              errors.telefonoContacto = "Teléfono de contacto inválido";
            if (
              record.telefonoContacto2?.length &&
              !matchIsValidTel(record.telefonoContacto2)
            )
              errors.telefonoContacto2 = "Teléfono de contacto 2 inválido";
            if (
              record.emailContacto?.length &&
              !ValidarEmail(record.emailContacto)
            )
              errors.emailContacto = "Email de contacto inválido";
            if (
              record.emailContacto2?.length &&
              !ValidarEmail(record.emailContacto2)
            )
              errors.emailContacto2 = "Email de contacto 2 inválido";

            if (!record.atencionesPrevias)
              errors.atencionesPrevias = "Dato requerido";
            if (record.atencionesPrevias === "S" && !record.tipoPrestador) {
              errors.tipoPrestador = "Dato requerido";
            }
            if (
              record.atencionesPrevias === "S" &&
              !record.conCoberturaOsprera
            ) {
              errors.conCoberturaOsprera = "Dato requerido";
            }

            if (!record.gestionObraSocialId)
              errors.gestionObraSocial = "Dato requerido";

            //ObservacionesEstado
            if (!record.observacionesEstado &&
              (record.gestionEstadoDescripcion === "RECLAMADO" ||
                (record.gestionEstadoDescripcion === "FINALIZADO" &&
                  record.gestionSituacionDescripcion === "CON RECLAMO FORMAL"))
            ) {
              errors.observacionesEstado = "Dato requerido";
            }
          }

          if (Object.keys(errors).length) {
            setList((o) => ({
              ...o,
              selection: {
                ...o.selection,
                errors,
              },
            }));
            return;
          }

          if (!list.remote) {
            const changes = {
              loading: "Cargando...",
              data: [...list.data],
            };
            switch (list.selection.request) {
              case "A": {
                record.id =
                  (Math.max(...changes.data.map((r) => r.id)) ?? 0) + 1;
                changes.data.push(record);
                break;
              }
              case "M": {
                changes.selection = { ...list.selection };
                AsArray(changes.selection.apply).forEach((id) => {
                  const index = changes.data.findIndex((r) => r.id === id);
                  if (index < 0) return;
                  const r = { ...changes.data.at(index), ...record };
                  if (changes.selection.multi) {
                    changes.selection.index ??= [];
                    changes.selection.record ??= [];
                    const i = changes.selection.record.findIndex(
                      (r) => r.id === id
                    );
                    if (i < 0) {
                      changes.selection.index.push(index);
                      changes.selection.record.push(r);
                    } else {
                      changes.selection.index[i] = index;
                      changes.selection.record[i] = r;
                    }
                  } else {
                    changes.selection.index = index;
                    changes.selection.record = r;
                  }
                  changes.data.splice(index, 1, r);
                });
                break;
              }
              case "B": {
                changes.selection = { ...list.selection };
                AsArray(changes.selection.apply).forEach((id) => {
                  const index = changes.data.findIndex((r) => r.id === id);
                  if (index < 0) return;
                  const r = {
                    ...changes.data.at(index),
                    deletedDate: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
                    deletedObs: record.deletedObs,
                  };
                  if (changes.selection.multi) {
                    const i = changes.selection.record.findIndex(
                      (r) => r.id === id
                    );
                    if (i < 0) {
                      changes.selection.index.push(index);
                      changes.selection.record.push(r);
                    } else {
                      changes.selection.index[i] = index;
                      changes.selection.record[i] = r;
                    }
                  } else {
                    changes.selection.index = index;
                    changes.selection.record = r;
                  }
                  changes.data.splice(index, 1, r);
                });
                break;
              }
              default:
                break;
            }
            list.onDataChange(changes.data);
            setList((o) => ({ ...o, ...changes }));
            return;
          }

          const query = {
            config: {},
            onOk: async (_res) => {
              setList((old) => ({ ...old, loading: "Cargando..." }));
              if (list.selection.request === "A") {
                onDownloadComprobanteGestion({
                  nroGestion: _res,
                  nombre: record.apellidoPaciente + " " + record.nombrePaciente,
                  fecha: moment(record.fecha).format("DD/MM/YYYY"),
                  seccional: record.seccionalDescripcion,
                  obraSocial: record.gestionObraSocialDescripcion,
                });
              }

              //NUEVO mauro
              // === ENVÍO DE EMAIL ===
              if (list.selection.request === "A" && record.medioGestion === "email") {
                try {
                  const adjuntos = AsArray(record.documentacion).map((r) => ({
                    fileName: r.nombreArchivo,
                    contentType: "application/octet-stream", // o usa el real si lo tienes
                    base64Data: r.archivo,
                  }));

                  const localidadUsuario = record.seccionalDescripcion ?? " ";

                  const emails = [
                    usuario?.email,
                    record?.emailContacto ?? [],
                    record?.emailContacto2 ?? [],
                  ];

                  const asuntoFinal = `UATRE - Nueva Gestión de Obra Social [Nro de Gestión: ${_res}]`;

                  pushQuery({
                    action: "EnviarCorreo",
                    config: {
                      body: {
                        to: [record?.direccionesEmailDestino] ?? [],
                        cco: emails.filter((email) => email),
                        attachments: adjuntos,
                        asunto: asuntoFinal,
                        cuerpo:
                          `<p><strong>${localidadUsuario}, ${moment().format("DD/MM/YYYY")}</strong><br></br>` +
                          `${record.gestionObraSocialDescripcion ?? ""}<br></br>${record.gestionAreaOspreraDescripcion ?? ""}<br></br><br></br>` +
                          `En representación del Afiliado <strong>${!!record.titularPaciente ? record?.apellidoTitular : record?.apellidoPaciente
                          } ${!!record.titularPaciente ? record?.nombreTitular : record?.nombrePaciente
                          }</strong>, con DNI Nº <strong>${record?.dniPaciente ?? ""}</strong>, Afiliado Nº <strong>${record?.cuitTitular ?? ""}</strong> ` +
                          `se solicita <strong>${record?.gestionRubroDescripcion ?? ""}</strong> sobre <strong>${record?.gestionSubRubro ?? ""}</strong> conforme lo que se detalla a continuación;<br></br>` +
                          `<strong>${record?.texto ?? ""}</strong>, adjuntando la documentación respectiva en su caso.<br><br/>` +
                          `Tipo de Adjuntos: <strong>${!Array.isArray(record.documentacion) || record.documentacion.length === 0
                            ? "Sin archivos adjuntos"
                            : record.documentacion.map((a) => a.refTipoDocumentacionDescripcion).join("/ ")
                          }</strong><br></br>` +
                          `Se requiere que se brinde la misma a la mayor brevedad posible o se me indique al mail o teléfono que se detalla al pie los pasos a seguir al respecto.<br><br/>` +
                          `La presente se origina por la imposibilidad del Afiliado de la referencia de realizarla por sus propios medios.<br><br/>` +
                          `En caso de negativa de respuesta al presente, el afiliado realizará la respectiva denuncia ante la Superintendencia de Servicios de Salud, por la falta de atención de parte de esa Obra Social.<br><br/>` +
                          `Muchas gracias.<br></br>MAIL: <strong>${usuario?.email ?? ""}</strong><br></br>TELEFONO: <strong>${usuario?.phoneNumber ?? ""}</strong></p>`,
                      },
                    },
                    onOk: () => { },
                    onError: (error) => {
                      alert(error?.message || "Error al enviar el email.");
                    },
                  });
                } catch (e) {
                  console.error("Fallo al preparar/enviar email:", e);
                }
              }


            },
            onError: async (err) => alert(err.message),
          };

          switch (list.selection.request) {
            case "A":
              query.action = "Create";
              query.config.body = record;
              break;
            case "M":
              query.action = "Update";
              query.params = { id: record.id };
              query.config.body = record;
              break;
            case "B":
              query.action = "Delete";
              query.params = { id: record.id };
              query.config.body = {
                id: record.id,
                deletedObs: record.deletedObs,
              };
              break;
            case "R":
              query.action = "Reactiva";
              //query.params = { id: record.id };
              query.config.body = { id: record.id };
              break;
            default:
              break;
          }
          pushQuery(query);
          //setList((o) => ({ ...o, loading: "Cargando..." }));
        }}
      />
    );
  }

  const render = () => (
    <>
      <GestionOSTable
        remote={list.remote}
        data={list.data}
        loading={!!list.loading || !!list.loadingOverride}
        noDataIndication={
          list.loading ??
          list.loadingOverride ??
          list.error?.message ??
          "No existen datos para mostrar"
        }
        columns={columns}
        mostrarBuscar={mostrarBuscar}
        filter={filterFactory()}
        pagination={{
          ...list.pagination,
          onChange: ({ index, size }) =>
            setList((o) => ({
              ...o,
              loading: "Cargando...",
              pagination: { index, size },
              data: o.remote ? [] : o.data,
            })),
        }}
        selection={{
          mode: list.selection.multi ? "checkbox" : "radio",
          hideSelectColumn: hideSelectColumn,
          selected: AsArray(list.selection.record, !list.selection.multi)
            .filter((r) => r)
            .map((r) => r.id),
          onSelect: (record, isSelect, rowIndex, e) => {
            if (rowIndex == null) return;
            setList((o) => {
              let index = o.data.findIndex((r) => r.id === record.id);
              if (o.selection.multi) {
                const newIndex = [];
                const newRecord = [];
                o.selection.record?.forEach((r, i) => {
                  if (!isSelect && r.id === record.id) return;
                  newIndex.push(o.selection.index[i]);
                  newRecord.push(r);
                });
                if (isSelect && !newIndex.includes(index)) {
                  newIndex.push(index);
                  newRecord.push(record);
                }
                if (newIndex.length) {
                  index = newIndex;
                  record = newRecord;
                } else {
                  index = null;
                  record = null;
                }
              }
              return {
                ...o,
                selection: {
                  ...o.selection,
                  ...selectionDef,
                  index,
                  record,
                },
              };
            });
          },
          onSelectAll: (isSelect, rows, e) => {
            if (!list.selection.multi) return;
            setList((o) => {
              let index = [];
              let record = [];
              if (isSelect) {
                o.data.forEach((r, i) => {
                  record.push(r);
                  index.push(i);
                });
              } else {
                index = null;
                record = null;
              }
              return {
                ...o,
                selection: {
                  ...o.selection,
                  ...selectionDef,
                  index,
                  record,
                },
              };
            });
          },
        }}
        onTableChange={(type, newState) => {
          switch (type) {
            case "sort": {
              let { sortField, sortOrder } = newState;
              sortField = { cuitTitular: "CUIT" }[sortField] ?? sortField;
              return setList((o) => ({
                ...o,
                loading: "Cargando...",
                params: {
                  ...o.params,
                  orderBy: `${sortField}${sortOrder === "desc" ? "Desc" : ""}`,
                },
              }));
            }
            default:
              return;
          }
        }}
      />
      {form}
    </>
  );

  return { render, request, selected: list.selection.record };
};

export default useGestionOS;